import Image from 'next/legacy/image'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { breakpoints, fontSizes } from '@/styles'

import bikersParadiseImgZh from './images/bikers_paradise_ZH.png'
import bikersParadiseImg from './images/bikers_paradise.png'
import ridersParadiseImgZh from './images/riders_paradise_ZH.png'
import ridersParadiseImg from './images/riders_paradise.png'
import walkersParadiseImgZh from './images/walkers_paradise_ZH.png'
import walkersParadiseImg from './images/walkers_paradise.png'

const WalkScoreContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  @media (max-width: ${breakpoints.phoneMax}) {
    margin-top: 40px;
  }
`

const WalkScoresContainer = styled.div`
  display: flex;
  max-width: 570px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media (max-width: ${breakpoints.phoneMax}) {
    flex-direction: column;
  }
`

const WalkScoreWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 180px;
  width: 140px;
  margin: 10px 25px;
`

const WalkScoreTitle = styled.p`
  font-size: 24px;
  margin-bottom: 30px;
`

const WalkScoreSubtitle = styled(WalkScoreTitle)`
  margin: 10px 0;
  font-size: ${fontSizes.regular};
  text-align: center;
`

const WalkScoreText = styled(WalkScoreSubtitle)`
  font-size: 12px;
`

const WalkScore = () => {
  const { t } = useTranslation('w2living')
  const router = useRouter()
  const isChinese = router.locale === 'zh'
  return (
    <WalkScoreContainer>
      <WalkScoreTitle>{t('w2living:Walk Score')}</WalkScoreTitle>
      <WalkScoresContainer>
        <WalkScoreWrapper>
          <Image
            src={isChinese ? walkersParadiseImgZh : walkersParadiseImg}
            alt="Walk score 95"
            width={80}
            height={80}
          />
          <WalkScoreSubtitle>
            {t(`w2living:Walker's Paradise`)}
          </WalkScoreSubtitle>
          <WalkScoreText>
            {t(
              'w2living:walker description',
              'Daily errands do not require a car.'
            )}
          </WalkScoreText>
        </WalkScoreWrapper>
        <WalkScoreWrapper>
          <Image
            src={isChinese ? ridersParadiseImgZh : ridersParadiseImg}
            alt="Transit score 93"
            width={80}
            height={80}
          />
          <WalkScoreSubtitle>
            {t(`w2living:Rider's Paradise`)}
          </WalkScoreSubtitle>
          <WalkScoreText>
            {t(
              'w2living:rider description',
              'World-class public transportation'
            )}
          </WalkScoreText>
        </WalkScoreWrapper>
        <WalkScoreWrapper>
          <Image
            src={isChinese ? bikersParadiseImgZh : bikersParadiseImg}
            alt="Bike score 99"
            width={80}
            height={80}
          />
          <WalkScoreSubtitle>
            {t(`w2living:Biker's Paradise`)}
          </WalkScoreSubtitle>
          <WalkScoreText>
            {t(
              'w2living:biker description',
              'Daily errands can be accomplished on a bike.'
            )}
          </WalkScoreText>
        </WalkScoreWrapper>
      </WalkScoresContainer>
    </WalkScoreContainer>
  )
}

export default WalkScore
